<template>
  <div id="app">
    <GlobalLoading />
    <Navbar/>
    <CallMe/>
    <Bottom/>
    <!-- <router-view v-if="isRouterAlive" /> -->
  </div>
</template>


<script>
import Navbar from './components/Navbar'
import CallMe from './components/CallMe'
import Bottom from './components/Bottom'
import GlobalLoading from './components/GlobalLoading'
export default {
  name: 'App',
  components: {
    Navbar,
    CallMe,
    Bottom,
    GlobalLoading,
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
}
</script>
<style lang="scss">
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  // background: #f9f9f9;
  background:#f9fcff;
  //滚动条样式
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #ccc;
  }
  ::-webkit-scrollbar-track {
    border-radius: 0;
    background: #eee;
  }
}
</style>
